export default "__VITE_ASSET__DLx_rMcP__"